/** Simulation-time jobs: pause, reset and destroy never leave browser timers behind. */
export class Timeline {
  private jobs: { at: number; run: () => void }[] = [];
  private time = 0;

  after(delay: number, run: () => void): void {
    this.jobs.push({ at: this.time + delay, run });
  }

  update(delta: number): void {
    this.time += delta;
    const due = this.jobs.filter((job) => job.at <= this.time);
    this.jobs = this.jobs.filter((job) => job.at > this.time);
    for (const job of due) job.run();
  }

  clear(): void {
    this.jobs = [];
    this.time = 0;
  }
}
